// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2l4M9","placeholdersHeader":"styles_placeholdersHeader__2w5qN","editorStyle":"styles_editorStyle__1IzgC","placeholdersBox":"styles_placeholdersBox__2AwdP"};